<template>
  <div>
    <b>Evasive maneuver type</b> : two types of scenarios can be designed with
    this module, future conjunction avoidance and relative proximity operations
    (RPO) situation escape, can be designed.

    <b>Reference date</b> : the reference date for the beginning of the timeline
    of actions. The constraints will be considered relative to this reference
    date. The reference date can therefore be chosen different from the orbits
    dates.
  </div>
</template>

<script>
export default {
  name: 'tooltipEvasiveScenario'
}
</script>
